import { useQuery, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { APIKEY, MerchantId } from "../../components/Keys";
import { axiosget, axiospost } from "../../helpers/httprequest";
import is_money from "../../helpers/is_money";
import swal from "../../helpers/swal";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";

const PayAcceptance = ({ v }) => {
  const queryClient = useQueryClient();

  const [loading, setloading] = React.useState(false);
  const { data, isLoading, error } = useQuery({
    queryKey: ["acceptanceFee"],
    queryFn: async () => {
      const req = await axiosget(`ms_acceptance_fee`);
      return req?.data;
    },
  });

  const amount = data?.reduce((a, { amount }) => a + amount, 0);

  const _generateRRR = async () => {
    try {
      const trxInfo = data?.shift();
      const req = await axiosget(`ms_acceptance_fee_rrr/${v?._id}`);
      if (req?.data === null) {
        const serviceTypeId = trxInfo.serviceID;
        const orderId = new Date().getTime();
        const merchantId = MerchantId;
        const apiKey = APIKEY;
        var apiHash = CryptoJS.SHA512(merchantId + serviceTypeId + orderId + amount + apiKey);
        const dataRRR = {
          serviceTypeId: serviceTypeId,
          amount: amount,
          orderId: orderId,
          payerName: `${v?.applicant.firstname} ${v?.applicant.middlename}  ${v?.applicant.lastname}`,
          payerEmail: v?.applicant?.emailaddress,
          payerPhone: v?.applicant?.phonenumber,
          description: `Payment for ${trxInfo.description}`,
        };

        const headerRRR = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `remitaConsumerKey=${merchantId},remitaConsumerToken=${apiHash}`,
          },
          method: "POST",
          body: JSON.stringify(dataRRR),
        };
        fetch("https://login.remita.net/remita/exapp/api/v1/send/api/echannelsvc/merchant/api/paymentinit", headerRRR)
          .then((r) => r.text())
          .then(async (r) => {
            const removeF = JSON.parse(r.substring(r.indexOf("{"), r.lastIndexOf("}") + 1));
            if (removeF?.RRR === undefined) {
              swal("error", removeF.statusMessage);
              return;
            }
            const fetch = await axiospost("ms_acceptance_fee_rrr", {
              application: v?._id,
              rrr: removeF.RRR,
              rrrdata: dataRRR,
            });
            if (fetch?.status !== 200) {
              swal("error", "Sorry, system could not store your RRR Code, please try and generate another RRR code");
              return;
            }
            swal(fetch?.data?.type, fetch?.data?.message);
            queryClient.invalidateQueries({ queryKey: ["acceptanceInformation"] });
            if (fetch?.data?.type !== "success")
              Swal.fire({ icon: "success", html: `Copy your Remita RRR<br/><h1>${removeF.RRR}</h1>`, title: "GENERATED REMITA PAYMENT" });
            setloading(false);
          });
      } else {
        Swal.fire({ icon: "success", html: `Copy your Remita RRR<br/><h1>${req?.data.RRR}</h1>`, title: "GENERATED REMITA PAYMENT" });
        setloading(false);
      }
    } catch ({ message }) {
      swal("error", message);
    }
  };
  return (
    <div className="text-right">
      {isLoading && <p>Please wait...</p>}
      {error && <p>Error encountered: {error?.message}</p>}
      {data && (
        <button disabled={loading} className="btn btn-primary" onClick={_generateRRR}>
          {loading ? (
            "Please wait..."
          ) : (
            <span>
              Pay {is_money(data?.reduce((a, { amount }) => a + amount, 0))} Acceptance Fee<i className="fa fa-pay"></i>
            </span>
          )}
        </button>
      )}
    </div>
  );
};

export default PayAcceptance;
